// Cheese data
const cheeses = [
  {
    id: 1,
    name: 'Swiss',
    description: 'Traditional Swiss cheese',
    base_price: 1.50
  },
  {
    id: 2,
    name: 'American',
    description: 'American cheese',
    base_price: 1.50
  },
  {
    id: 3,
    name: 'Cheddar',
    description: 'Sharp cheddar cheese',
    base_price: 1.50
  },
  {
    id: 4,
    name: 'Provolone',
    description: 'Mild provolone cheese',
    base_price: 1.50
  },
  {
    id: 5,
    name: 'Muenster',
    description: 'Creamy muenster cheese',
    base_price: 1.50
  },
  {
    id: 8,
    price_override_key: 'pepper-jack',
    name: 'Pepper Jack',
    description: 'Creamy cheese with a peppery kick',
    base_price: 1.50
  },
  {
    id: 9,
    price_override_key: 'baby-swiss',
    name: 'Baby Swiss',
    description: 'Mild, creamy Swiss cheese',
    base_price: 1.50
  },
  {
    id: 10,
    price_override_key: 'jarlsberg',
    name: 'Jarlsberg',
    description: 'Rich, nutty Swiss-style cheese',
    base_price: 3.00
  }
];

export default cheeses;
